import PointInfo from './PointInfo';

export default PointInfo;
